import VirtualCanvas from '../_internal/components/canvases/vcanvas.js';
import { componentFactory } from '../../../fc-core/src/lib';
export default function (a) {
  var b,
      c,
      d,
      e,
      f,
      g,
      h,
      m = a.getChildren('canvas'),
      n = m.length,
      o = [],
      p = [];

  for (e = 0; e < n; e++, o = [], p = []) {
    if (b = m[e], !b.getState('removed')) {
      for (d = b.getFromEnv('xAxis'), g = 0; g < (d && d.length); g++) {
        d[g].getState('removed') || o.push(d[g]);
      }

      for (d = b.getFromEnv('yAxis'), g = 0; g < (d && d.length); g++) {
        d[g].getState('removed') || p.push(d[g]);
      }

      for (componentFactory(b, VirtualCanvas, 'vCanvas', o.length * p.length), c = b.getChildren('vCanvas'), (f = 0, g = 0); f < (o && o.length); f++) {
        for (h = 0; h < (p && p.length); h++, g++) {
          c[g].xAxis(o[f]).yAxis(p[h]).canvas(b), c[g].configure(), c[g].addToEnv('vCanvas', c[g]);
        }
      }
    }
  }
}